<script>

</script>

<style type="text/scss">
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvY29tcG9uZW50cy9OYXZiYXIuc3ZlbHRlIn0= */</style>

<div class="navbar absolute w-full bg-white top-0 left-0">
    <div class="container py-6 flex items-center justify-between">
        <div class="logo text-grey-dark flex flex-row leading-none items-center">
            <img src="boxfish-logo.svg" class="mr-4" />
            <div class="flex flex-col">
                <span class="font-bold ">BOXFISH</span>
                <span>studio{'\n'}</span>
            </div>
        </div>
        <div class="contact text-xs flex flex-col md:block">
            <a class="mr-2 mb-2 md:mb-0" href="mailto:covid19@boxfish.studio">covid19@boxfish.studio</a>
            <a href="tel:+34910 615212">+34 910 615212</a>
        </div>
    </div>
</div>
